<template>
<div>
  <vue-headful :title="site_title" />
  <Header :displayLoginBox="true" />

  <template v-for="(forumSection, index) in forums">
    <ForumSection :forum="forumSection" />
    <span v-if="index < forums.length-1"><br></span> <!-- br for all except last forum section -->
  </template>
  <FooterPermanent v-if="this.footerReady" :loadTime="this.loadTime" :totalRequests="0" />
</div>
</template>

<script>
import Header from './Header'
import ForumSection from './ForumSection'
import FooterPermanent from './FooterPermanent'

export default {
  components: {
    Header,
    ForumSection,
    FooterPermanent
  },
  data: function() {
    return {
      forums: null,
      footerReady: false
    }
  },
  async created() {
    console.time("PageLoadTime");
    let dateEarly = new Date();
    let response = await fetch(this.getNodePath());
    let dateLater = new Date();
    let data = await response.json();
    data.forEach(el => {
      el.hide = false;
    });
    this.forums = data;
    //console.log(this.forums);
    this.loadTime = this.spanSeconds(dateEarly, dateLater);
    this.footerReady = true;
    console.timeEnd("PageLoadTime");
  }
}
</script>

<style lang="scss">
</style>
